import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ExposureTaskSample } from 'src/app/models/exposureBySeg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-task-samples',
  templateUrl: './task-samples.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./task-samples.component.scss']
})
export class TaskSamplesComponent {
  @Input() loadingExposureTaskSamples: boolean = true;
  @Input() exposureTaskSamples: ExposureTaskSample[];

  @Output() redirectToSampleEmit = new EventEmitter<any>();
  @Output() sortExposureTaskSamplesEmit = new EventEmitter<any>();
  
  errorMessage: string = "";

  constructor() {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  redirectToSample(sensorAssignmentId) {
    this.redirectToSampleEmit.emit(sensorAssignmentId);
  }

  sortExposureTaskSamples(data){
    this.sortExposureTaskSamplesEmit.emit(data)
  }

  public trackByIndex = trackByIndex;
}
